"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayInvoice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const money_gif_1 = __importDefault(require("../../../../assets/gifs/money.gif"));
const error_gif_1 = __importDefault(require("../../../../assets/gifs/error.gif"));
const pay_module_css_1 = __importDefault(require("./pay.module.css"));
const titleTgStyles = { color: 'var(--tg-theme-text-color)' };
const InputStyle = { color: 'var(--tg-theme-text-color)' };
const PayInvoice = (props) => {
    // const buyApi = new BuyApi()
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    // const tonApi = new TonApi()
    // const [ isLoading, setIsLoading ] = useState<boolean>(false)
    (0, react_1.useEffect)(() => {
        if (props.position !== 3)
            return;
        TgObj.MainButton.show();
        if (props.position !== 3 || !props.apiResponce) {
            TgObj.MainButton.disable();
            TgObj.MainButton.text = t('send-status.invoice-err');
            TgObj.MainButton.color = '#9a9c9a';
        }
        else {
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('send-status.pay-invoice-btn');
        }
        TgObj.MainButton.onClick(props.handleBtnPay);
        return () => {
            TgObj.MainButton.offClick(props.handleBtnPay);
        };
    }, [props.position === 3, props.sendData.token, props.sendData]);
    (0, react_1.useEffect)(() => {
        if (props.apiResponce) {
            props.setSuccess(true);
        }
        else {
            props.setSuccess(false);
        }
    }, [props.apiResponce]);
    const handleOpenLink = () => {
        if (!props.apiResponce) {
            alert('Empty response');
            return;
        }
        if ('confirmationUrl' in props.apiResponce) {
            window.open(props.apiResponce?.confirmationUrl, '_blank');
        }
        else if ('verificationUrl' in props.apiResponce) {
            window.open(props.apiResponce?.verificationUrl, '_blank');
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: pay_module_css_1.default.wrapper, children: (0, jsx_runtime_1.jsx)("div", { className: pay_module_css_1.default.modal, children: (0, jsx_runtime_1.jsx)("div", { className: `${pay_module_css_1.default.modalContent}`, children: props.apiResponce ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: money_gif_1.default, alt: "success" }), (0, jsx_runtime_1.jsxs)("p", { className: pay_module_css_1.default.modalContentTitle, onClick: handleOpenLink, children: [t('send-status.your-invoice'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", t('send-status.inv-sent-successfully')] }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pay_module_css_1.default.modalContentText, children: t('send-status.pay-invoice') })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: error_gif_1.default, alt: "success" }), (0, jsx_runtime_1.jsxs)(de_ui_1.Title, { variant: "h3", className: pay_module_css_1.default.modalContentTitle, children: [t('send-status.your-invoice'), " ", (0, jsx_runtime_1.jsx)("br", {}), " ", t('send-status.failed')] }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pay_module_css_1.default.modalContentText, children: t('send-status.service-err') })] })) }) }) }));
};
exports.PayInvoice = PayInvoice;
